import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { useClient } from '../../../app/api/client-api';
import { getLiquidityOneOffCashflowSettings, type PanelSettingsDto } from '../../../app/api/generated/client';
import { queryKeys } from '../query-keys';

export function useLiquidityOneOffCashflowSettings(): UseQueryResult<PanelSettingsDto, AxiosError> {
    const { data: client } = useClient();
    const queryKey = useMemo(() => queryKeys.liquidityOneOffCashflowSettings(client?.partnerUuid), [client?.partnerUuid]);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getLiquidityOneOffCashflowSettings({ query: { clientId: client!.id }, signal }).then((result) => result.data),
        enabled: !!client,
    });
}
